import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { PermissionKey } from '@app/models/settings/permissions.model';
import { PermissionsDirective } from '@app/shared/directives/permissions/permissions.directive';

@Component({
  selector: 'app-empty-state-placeholder',
  templateUrl: './empty-state-placeholder.component.html',
  styleUrl: './empty-state-placeholder.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    AngularSvgIconModule,
    PermissionsDirective
  ]
})
export class EmptyStatePlaceholderComponent {
  icon = input<string>();
  showCircleBg = input<boolean>(false);
  size = input<number | 'auto'>('auto');
  text = input<string>('commonNotifications.noResultsFound');
  description = input<string>();
  showButton = input<boolean>(true);
  buttonLabel = input<string>('buttons.add');
  managePermissions = input<PermissionKey[]>();
  isEditable = input<boolean>(true);

  buttonClicked = output<void>();
}
